export const SET_VALUE_COTACAO = "SET_VALUE_COTACAO";
export const SET_PAISES_COTACAO = "SET_PAISES_COTACAO";
export const SET_RESULT_COTACAO = "SET_RESULT_COTACAO";
export const SET_FORM_COTACAO = "SET_FORM_COTACAO";
export const SET_LOADING_COTACAO = "SET_LOADING_COTACAO";
export const SET_LIMITES_PAIS_MOEDAS = "SET_LIMITES_PAIS_MOEDAS";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_ULT_ALT_VR = "SET_ULT_ALT_VR";

















